import React from 'react'

import '../App.css'

function Header() {
    return (
        <div className="flex-container-row centered header">
            <div className="letters red"><h2>F</h2></div>
            <div className="letters tilt-r"><h2>L</h2></div>
            <div className="letters tilt"><h2>A</h2></div>
            <div className="letters red"><h2>S</h2></div>
            <div className="letters tilt-r"><h2>H</h2></div>
            <div className="letters red"><h2>C</h2></div>
            <div className="letters tilt"><h2>A</h2></div>
            <div className="letters red"><h2>R</h2></div>
            <div className="letters tilt-r"><h2>D</h2></div>
            <div className="letters red"><h2>S</h2></div>
            {/* <h1>Flash Cards</h1> */}
        </div>
    )
}

export default Header